import { render, staticRenderFns } from "./MeldeCards.vue?vue&type=template&id=53ab30dd&"
import script from "./MeldeCards.vue?vue&type=script&lang=js&"
export * from "./MeldeCards.vue?vue&type=script&lang=js&"
import style0 from "./MeldeCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports